"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lighthouse_config_1 = require("../../lighthouse.config");
exports.default = async (pageNo, authToken) => {
    try {
        const endpoint = `${lighthouse_config_1.lighthouseConfig.lighthouseDataDepot}/api/data/get_user_uploads?pageNo=${pageNo}`;
        const fileList = (await axios_1.default.get(endpoint, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            }
        })).data;
        return { data: fileList };
    }
    catch (error) {
        throw new Error(error);
    }
};
